import React, { useState, useEffect, useRef} from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import Clicker from './Clicker';
import Chat from './Chat';
import Header from './Navbar';
import {useChatOn, useWindowSize} from './reusableHooks';
import { useHistory } from 'react-router-dom';

function Attendee({thisUser}) {
  const history = useHistory();
  const windowSize = useWindowSize();
  const [radioValue, setRadioValue] = useState('1');
  const mountedRef = useRef(false);
  
  const sessionId = localStorage.getItem('currentSession')? localStorage.getItem('currentSession') : null;
  const sessionChatOn = useChatOn(sessionId);
  if(thisUser && !thisUser.isAnonymous) history.push("/");

  const checkButton = (buttonValue) => {
    if(buttonValue==='1' && mountedRef.current){
      setRadioValue('1');
    }
    else if(buttonValue==='2' && mountedRef.current){
      setRadioValue('2');
    }
  }

  //clean up on unmount
  useEffect(() => {
    mountedRef.current = true;

    return () => {mountedRef.current = false;}
  })

  return (
    <div className="inner-app attendee sm">
        <Header type="attendee"/>
        <div id="parent" key="parent" className="attendee">
          {sessionId && <Clicker sessionId={sessionId} thisUser={thisUser} isAdmin={false} sessionChatOn={sessionChatOn} windowSize={windowSize} radioValue={radioValue} checkButton={checkButton}/>}
          {sessionId && <Chat sessionId={sessionId} thisUser={thisUser} isAdmin={false} isSessionChatOn={sessionChatOn} windowSize={windowSize} radioValue={radioValue} checkButton={checkButton}/>}
        </div> 
    </div>
  );
}

export default Attendee;
